import { useState, useEffect } from 'react'

type NavMode = 'mobile' | 'topbar' | 'sidebar'

function getMode(): NavMode {
  if (typeof window === 'undefined') return 'sidebar'
  const { innerWidth: w, innerHeight: h } = window
  if (w < 640) return 'mobile'
  if (w >= 1024 && w > h) return 'sidebar'
  return 'topbar'
}

export function useNavLayout(): NavMode {
  const [mode, setMode] = useState<NavMode>(getMode)

  useEffect(() => {
    const handler = () => setMode(getMode())
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return mode
}
